import React from 'react'
import '../../styles/Advisors/AdvisorsShared.scss'

interface ProfileStatProps {
    label: string
    value: React.ReactNode
}

const ProfileStat = ({ label, value }: ProfileStatProps) => (
    <div className={`profile_stat${label === 'Distance From You' ? ' distance-stat' : ''}`}>
        {label}:
        <span>{value}</span>
    </div>
)

export default ProfileStat
